export default __webpack_public_path__ + "static/media/upload.eca54c7c.svg";